import LoaderView from "./Loader.view";

export default function LoginContainer() {
    return (
        <>
            <LoaderView />
        </>
    );
}
